import React, { useEffect, useState } from "react";
import liracrypt from "../../components/Liracrypt/liracrypt";
import { Form, Row, Col, Modal, notification, Table, Card, Tooltip, Select } from "antd";
import Button from "../../components/ReportFormGenerator/Button/Button";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import SessionError from "../../components/ApiErrorComp/SessionError";
import InputIdentify from "../../pages/InputCreater/InputCreater";
import StablePrime from "../../components/Tables/StablePrime";
import moment from "moment";
import { useParams, useLocation } from "react-router-dom";
import {
    EditOutlined,
    DeleteOutlined,
    EyeOutlined,
    LoadingOutlined,
    SolutionOutlined,
    MobileOutlined,
    ControlOutlined,
    FileJpgOutlined,
    FileSearchOutlined,
    SwitcherOutlined,
    AuditOutlined,
  ProfileOutlined


} from "@ant-design/icons";
import { useSelector } from "react-redux";

function LivoPhantomPrime({
    setPageHeader,
    setPageTitle,
    urlEndpoint,
    urlData,
    pageName,
    colSpan,
    btnMargin,
    extraData,
    urlMethod,
    filterType = "",
    button = "default",
    layoutPosition,
    showInput = true,
}) {
    if (setPageHeader) {
        setPageHeader(pageName);
    }
    const { search } = useLocation();
    const urlCode = useSelector(state => state.urlCode);
    const [selectedUrlData, setSelectedUrlData] = useState({
        'mod': '',
        'pno': '',
        'opt': '',
        'typ': 'Model',
        'subTyp': 'idame'
    });
    const [modelData, setModelData] = useState();
    const [partData, setParData] = useState();
    const [optionsData, setOptionsData] = useState();
    const [stationData, setStationData] = useState();
    const [modalData, setModalData] = useState();
    const icons = {
        EditOutlined,
        DeleteOutlined,
        EyeOutlined,
        LoadingOutlined,
        SolutionOutlined,
        MobileOutlined,
        ControlOutlined,
        FileJpgOutlined,
        FileSearchOutlined,
        SwitcherOutlined,
        AuditOutlined,
  ProfileOutlined
    }
    
    const [auxTableData, setAuxTableData] = useState();
    const [url, setUrl] = React.useState(null);
    const [method, setMethod] = React.useState(null);
    const [loading, setLoading] = React.useState(false);
    const [loginError, setLoginError] = React.useState(false);
    const [render, setRender] = React.useState(true);
    const [formData, setFormData] = React.useState(null);
    const [fro, setFro] = React.useState(null);
    const [showInp, setShowInp] = React.useState(showInput);
    const { docNo } = useParams();
    const [form] = Form.useForm();

    const LocalDict = [];
    const dtArray = ["datePicker", "rangePicker", "dateTimePicker"];

    const now = new Date();

    function setPhantomData(key, value) {
        let __key = `cache_${key}`;
        const now = new Date();

        const item = {
            value: value,
            expiry: now.getTime() + 28800000,
        };
        localStorage.setItem(__key, JSON.stringify(item));
    }

    function getPhantomData(key) {
        let __key = `cache_${key}`;
        const itemStr = localStorage.getItem(__key + "Page");
        // if the item doesn't exist, return null
        if (!itemStr) {
            return null;
        }
        const item = JSON.parse(itemStr);
        const now = new Date();
        // compare the expiry time of the item with the current time
        // if (now.getTime() > item.expiry) {
        //   // If the item is expired, delete the item from storage
        //   // and return null
        //   localStorage.removeItem(key);
        //   return null;
        // }
        return item.value;
    }

    React.useEffect(() => {
        const d = getPhantomData(urlData["dictName"]);
        if (d) {
            setUrl(d.config?.url);
            setMethod(d.config?.method);
            setAuxTableData(d.config?.aux);
            setPageTitle(d.config?.aux1);
            setRender(false);
        } else {
            ////
            if (!urlMethod) {

                liracrypt
                    .get("/livo/landingpage/landingdata", urlData)
                    .then((res, req) => {
                        
                        setPageTitle(res.data.config?.aux1);
                        setPhantomData(urlData["dictName"], res.data);

                        setUrl(res.data.config?.url);
                        setMethod(res.data.config?.method);
                        setAuxTableData(res.data.config?.aux);
                        setRender(false);
                        if (search.includes("autoSubmit=true")) {
                            document.getElementById("submitButtonForm").click();
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        if (err.response !== undefined) {
                            if (err.response.status !== 401) {
                                // ApiErrorComp(err.response.status);
                            } else {
                                setLoginError(true);
                            }
                        }
                    });
            } else {
                if (urlMethod === "POST") {
                    liracrypt
                        .post("/miscellaneous/pageconfig", urlData)
                        .then((res, req) => {
                            

                            setPhantomData(urlData["dictName"], res.data);

                            setUrl(res.data.config?.url);
                            setMethod(res.data.config?.method);
                            setAuxTableData(res.data.config?.aux);
                            setPageTitle(res.data.config?.aux1);
                            setRender(false);
                        })
                        .catch((err) => {
                            console.log(err);
                            if (err.response !== undefined) {
                                if (err.response.status !== 401) {
                                    // ApiErrorComp(err.response.status);
                                } else {
                                    setLoginError(true);
                                }
                            }
                        });
                }
                if (urlMethod === "PATCH") {
                    liracrypt
                        .patch("/miscellaneous/pageconfig", urlData)
                        .then((res, req) => {
                            

                            setPhantomData(urlData["dictName"], res.data);

                            setUrl(res.data.config?.url);
                            setMethod(res.data.config?.method);
                            setAuxTableData(res.data.config?.aux);
                            setPageTitle(res.data.config?.aux1);

                            setRender(false);
                        })
                        .catch((err) => {
                            console.log(err);
                            if (err.response !== undefined) {
                                if (err.response.status !== 401) {
                                    // ApiErrorComp(err.response.status);
                                } else {
                                    setLoginError(true);
                                }
                            }
                        });
                }
            }
            ////
        }

        return () => { };
    }, []);

    const onFinish = (value) => {
        

        Object.keys(value).forEach((key, i) => {
            
            if (value[key]) {
                if (Array.isArray(value[key]) && LocalDict[key]) {
                    value[
                        LocalDict["data_index_from"] ? LocalDict["data_index_from"] : "from"
                    ] = moment(value[key][0]).format(LocalDict[key]).toString();
                    value[
                        LocalDict["data_index_to"] ? LocalDict["data_index_to"] : "to"
                    ] = moment(value[key][1]).format(LocalDict[key]).toString();
                    delete value[key];
                } else {
                    if (LocalDict[key]) {
                        value[key] = moment(value[key]).isValid()
                            ? moment(value[key]).format(LocalDict[key]).toString()
                            : value[key];
                    }
                    // } else {
                    //   value[key] = moment(value[key]).isValid()
                    //     ? moment(value[key]).toString()
                    //     : value[key];
                    // }
                }
            }
        });

        Object.keys(value).forEach((element) => {
            if (Array.isArray(value[element])) {
                let filtered = value[element].filter(function (el) {
                    return el != null;
                });
                let temp = filtered.toString();
                value[element] = "[" + temp + "]";
            }
        });
        setFormData({ ...value, ...urlData });
    };

    const DataTable = ({ url }) => {
        return (
            <>
                {formData ? (
                    <StablePrime url={url} data={formData} zenTable={true} identity="DataTable" />
                    // <StablePrime editSingleColumn={true} zenTable={true} url={"qc/auditsession"} data={{typ: "fourm",  event: docNo }} identity="DataTable" />





                ) : (
                    <></>
                )}
            </>
        );
    };

    React.useEffect(() => {
        let queryData = {};
        const params = new URLSearchParams(window.location.search);

        for (var key of params.keys()) {
            queryData[key] = params.get(key);
            if (key === "showInput") {
                setShowInp(params.get(key) == "true" ? true : false);
                setFormData(queryData);
            }
        }

        // console.log(url);
        // console.log(d);

        // Object.keys(params).forEach((data, index) => {
        //   console.log(params);
        //   queryData[data] = params.get(data);
        // });
        // setFormData(queryData);
    }, []);


    const IconComponent = (props) => {
        const Icon = props.icon;
        
        return Icon ? <Icon {...props} /> : <></>
    }

    const onECNrowClick = (action) => {
        if (action.url) {
            window.open(`/v02/${urlCode}` + action.url, "_blank");
        } else {
            setFormData({ ...action.auxParams, ...urlData });
        }
    }
    // let data = api.split("?");
    // let __formData = {};
    // console.log(data);
    // data = data[1].split('&');
    // data.forEach(x => {
    //     let key = x.split("=")[0];
    //     let value = x.split("=")[1];
    //     __formData[key] = value;
    // });
    // delete __formData.token;
    // setFormData(__formData);


    const onItemSelect = ({ value, key, typ }) => {
        setSelectedUrlData({
            ...selectedUrlData,
            [key]: value,
            typ
        })
    }


    useEffect(() => {
        
        if (selectedUrlData.typ) {
            liracrypt.get('/livo/livodict', selectedUrlData)
                .then(response => {
                    let data = { ...response.data.data };
                    let respData = [
                        {label: 'All', value: 'all'}
                    ];
                    // let respData = [
                       
                    // ];
                    Object.keys(data).forEach(x => {
                        respData.push({
                            value: x,
                            label: data[x]
                        })
                    });
                    
                    if (selectedUrlData.typ === 'Model') {
                        setModelData(respData);
                    }
                    if (selectedUrlData.typ === 'Part') {
                        setParData(respData);
                    }
                    if (selectedUrlData.typ === 'Option') {
                        setOptionsData(respData);
                    }
                    if (selectedUrlData.typ === 'Station') {
                        setStationData(respData);
                    }
                    if (selectedUrlData.typ === 'Part') {
                        setParData(respData);
                    }
                   
                   
                }).catch(err => {
                    console.log(err);
                })
        }
    }, [selectedUrlData]);

    const resetSopInfo = () => {
        form.resetFields();
        setSelectedUrlData({
            'mod': '',
            'pno': '',
            'opt': '',
            'typ': 'Model',
            'subTyp': 'idame'
        });
        setOptionsData(null);
        setParData(null);
        setStationData(null);
        setFormData(null);
    }


    return (
        <>
            <SessionError loginError={loginError} />
            <div style={filterType === 'sideBar' ? { display: 'flex' } : {}}>
                {showInp ? (
                    <div className={`AuditSection CreateAudit ${filterType}`} style={{ padding: "10px" }}>
                        <div className="ThemeForm" style={{ boxShadow: "rgb(23 23 23) 5px 5px 9px, rgb(35 35 35) -5px -5px 9px", padding: 10 }}>
                            <h1 style={{ color: '#ffffff', textAlign: 'center' }}>SOP Information</h1>
                            <Form
                                name="ReportForm"
                                form={form}
                                labelCol={{ span: 8 }}
                                wrapperCol={{ span: 16 }}
                                layout="horizontal"
                                colon={false}
                                onFinish={onFinish}
                                size="large"
                            >
                                <div
                                    className="settingModal"
                                    style={{
                                        maxHeight: "400px",
                                        overflowY: "scroll",
                                        overflowX: "hidden",
                                    }}>
                                    <Form.Item
                                        labelCol={12}
                                        name={"mod"}
                                        label={"Model"}
                                        style={{ marginRight: "10px", fontWeight: 600 }}
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please Select One',
                                            },
                                        ]}
                                    >
                                        <Select
                                            showSearch={true}
                                            onChange={(value) => onItemSelect({ value, key: 'mod', typ: 'Option' })}
                                            placeholder={'Please Select'}
                                            defaultActiveFirstOption={true}
                                            disabled={selectedUrlData.mod ? true : false}
                                            options={modelData}
                                        />
                                    </Form.Item>
                                    {
                                        optionsData && (
                                            <Form.Item
                                                labelCol={12}
                                                name={"opt"}
                                                label={"Option"}
                                                style={{ marginRight: "10px", fontWeight: 600 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please Select One',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch={true}
                                                    onChange={(value) => onItemSelect({ value, key: 'opt', typ: 'Station' })}
                                                    placeholder={'Please Select'}
                                                    defaultActiveFirstOption={true}
                                                    disabled={selectedUrlData?.opt ? true : false}
                                                    options={optionsData}
                                                />
                                            </Form.Item>
                                        )
                                    }
                                    {
                                        stationData && (
                                            <Form.Item
                                                labelCol={12}
                                                name={"stnid"}
                                                label={"Station"}
                                                style={{ marginRight: "10px", fontWeight: 600 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please Select One',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch={true}
                                                    disabled={selectedUrlData.stnid ? true : false}
                                                    onChange={(value) => onItemSelect({ value, key: 'stnid', typ: 'Part' })}
                                                    placeholder={'Please Select'}
                                                    defaultActiveFirstOption={true}
                                                    options={stationData}
                                                />
                                            </Form.Item>
                                        )
                                    }
                                    {
                                        partData && (
                                            <Form.Item
                                                labelCol={12}
                                                name={"pno"}
                                                label={"PartNo"}
                                                style={{ marginRight: "10px", fontWeight: 600 }}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Please Select One',
                                                    },
                                                ]}
                                            >
                                                <Select
                                                    showSearch={true}
                                                    placeholder={'Please Select'}
                                                    defaultActiveFirstOption={true}
                                                    disabled={false}
                                                    options={partData}
                                                />
                                            </Form.Item>
                                        )
                                    }
                                </div>

                                <Row gutter={24} justify="center">
                                    <Col span={12}>
                                        {
                                            button === 'default' ?
                                                <Button
                                                    form={form}
                                                    // marginLeft={btnMargin ? btnMargin : "320px"}

                                                    loading={loading}
                                                    cancelButtonText={"Reset"}
                                                    submitButtonText={"Submit"}
                                                    resetButton={true}
                                                /> :
                                                <Button width={"100%"} submitButtonText="Search" form={form} loading={loading} />
                                        }
                                    </Col>
                                    <Col span={12}>
                                        <Button noSubmit={true} onClick={resetSopInfo} type="danger" width={"100%"} submitButtonText="Reset" loading={loading} />
                                    </Col>
                                </Row>
                            </Form>
                        </div>
                        {
                            auxTableData ? (
                                // <SummaryComponent TblConfig={auxTableData}  />
                                <div className="ecn-information-wrapper">
                                    <h1>ECN Information</h1>
                                    <table className="ecn-information-table">
                                        <thead>
                                            <th>ECN No</th>
                                            <th>Model</th>
                                            <th></th>
                                        </thead>
                                        {
                                            auxTableData.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{item.col1}</td>
                                                    <td>{item.col2}</td>
                                                    <td style={{ display: 'inline-flex' }}>
                                                        {
                                                            Object.keys(item.action).map((x, i) => (
                                                                <Tooltip placement="bottom" title={item.action[x].toolTip}>
                                                                    <IconComponent
                                                                        icon={icons[item.action[x].icon]}
                                                                        style={{
                                                                            marginRight: "15px",
                                                                            color: "#1890ff",
                                                                            fontSize: "25px",
                                                                        }}
                                                                        onClick={() => { onECNrowClick(item.action[x]) }}
                                                                    />{" "}
                                                                </Tooltip>
                                                            ))
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </table>
                                </div>
                            ) : (
                                <div className="ecn-information-wrapper">
                                    <h1>No ECN For Today </h1>
                                </div>
                            )
                        }
                    </div>
                ) : (
                    <>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                minHeight: "80vh",
                            }}
                        >
                            <LoadingOutlined
                                style={{ fontSize: 80, color: "#007bff" }}
                                spin
                            />
                        </div>
                    </>
                )}
                <>
                    {url && Array.isArray(url) ? (
                        <>
                            {url.map((data, index) => {
                                
                                return <DataTable url={data} />;
                            })}
                        </>
                    ) : (
                        <>
                            <DataTable url={url} />
                        </>
                    )}
                </>
            </div>
        </>
    );
}

export default LivoPhantomPrime;
